var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.101 19.23c-.466-.764-1.37-2.243-1.837-3.005-.465-.764-1.318-.616-2.024-.231l-1.111.606c-1.314.716-3.418-2.288-3.918-3.106-.5-.819-2.2-4.043-.887-4.759l1.11-.605c.707-.386 1.269-1.01.802-1.773L9.399 3.351c-.466-.764-1.448-.609-2.055-.278-.604.33-6.775 2.35-.667 12.349 6.109 9.998 11.046 5.96 11.653 5.629.605-.33 1.239-1.058.771-1.821z",
    fill: "#FFE14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fccca58e9fa3acf0891c547b58c345e9.svg";
export { ForwardRef as ReactComponent };